/**
 * @format
 * @flow
 */
import axios from 'axios';
import * as Task from '../constants/reducers/Task';
import * as Api from '../constants/Api';
import { loadStart, loadEnd, modalOpen, modalClose } from './App';
import { getTaskCategories } from '../db/categories';
import { getLicenses } from '../db/licenses';

export const getCategories = token => {
  return dispatch => {
    dispatch(getTaskCategories(token)).then(result => {
      dispatch(taskCategorySave(result));
    });
  };
};

export const taskCategorySave = data => {
  return {
    type: Task.SAVE_CATEGORY,
    data
  };
};

export const getLicensesInTask = licenseId => {
  return dispatch => {
    dispatch(getLicenses(licenseId)).then(result => {
      dispatch(licensesSave(result.datas));
    });
  };
};

export const licensesSave = data => {
  return {
    type: Task.LICENSES_SAVE,
    data
  };
};

export const modalCloseInTask = () => {
  return dispatch => {
    dispatch(modalClose());
  };
};

// 現在のタスク一覧取得
export const getCurrentTask = (datas, token, pageOffset, pageSize) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(
        Api.getCurrentTaskApi,
        {
          code: 'currentTask',
          ...datas,
          pageOffset,
          pageSize
        },
        {
          headers: { Authorization: token }
        }
      )
      .then(res => {
        // eslint-disable-next-line no-param-reassign
        res = JSON.parse(res.data.body);
        if ('errorMessage' in res) {
          dispatch(modalOpen(res.errorMessage, '失敗'));
        } else {
          dispatch(saveCurrentTasks(res.data));
        }
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(loadEnd());
      });
  };
};

export const saveCurrentTasks = data => {
  return {
    type: Task.GET_MY_TASKS,
    data
  };
};

export const resetCurrentTasks = () => {
  return {
    type: Task.RESET_TASK_DETAIL
  };
};

// 過去のタスク一覧取得
export const getOldTask = (datas, token, pageOffset, pageSize) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(
        Api.getOldTaskApi,
        {
          code: 'oldTask',
          ...datas,
          pageOffset,
          pageSize
        },
        {
          headers: { Authorization: token }
        }
      )
      .then(res => {
        // eslint-disable-next-line no-param-reassign
        res = JSON.parse(res.data.body);
        if ('errorMessage' in res) {
          dispatch(modalOpen(res.errorMessage, '失敗'));
        } else {
          dispatch(saveOldTasks(res.data));
        }
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(loadEnd());
      });
  };
};

export const saveOldTasks = data => {
  return {
    type: Task.GET_OLD_TASKS,
    data
  };
};

export const resetOldTasks = () => {
  return {
    type: Task.RESET_OLD_TASKS
  };
};

export const getTaskContractContent = (enterpriseId, token, taskId, taskrewId) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(
        Api.taskContractApi,
        {
          code: 'contract_get',
          enterpriseId,
          taskId,
          taskrewId
        },
        {
          headers: { Authorization: token }
        }
      )
      .then(res => {
        // eslint-disable-next-line no-param-reassign
        res = JSON.parse(res.data.body);
        if ('errorMessage' in res) {
          dispatch(modalOpen(res.errorMessage.errMsg, '失敗'));
        } else {
          dispatch(saveContractContent(res.data));
        }
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(loadEnd());
      });
  };
};

export const saveContractContent = data => {
  return {
    type: Task.TASK_CONTRACT_CONTENT,
    data
  };
};

export const resetContractContent = () => {
  return {
    type: Task.RESET_CONTRACT_CONTENT
  };
};

export const saveTaskContractContent = (token, enterpriseId, taskId, taskrewId, datas) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(
        Api.taskContractApi,
        {
          code: 'contract_set',
          enterpriseId,
          taskId,
          taskrewId,
          datas
        },
        {
          headers: { Authorization: token }
        }
      )
      .then(res => {
        res = JSON.parse(res.data.body);
        if ('errorMessage' in res) {
          console.log('TCL: saveTaskContractContent -> res', res);
          const errMsg = res.errorMessage.errMsg;
          if (isEmpty(errMsg)) {
            dispatch(modalOpen('正常に保存'));
          } else {
            dispatch(modalOpen('失敗'));
          }
        } else {
          dispatch(modalOpen('正常に保存', ''));
        }
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(loadEnd());
      });
  };
};

var hasOwnProperty = Object.prototype.hasOwnProperty;

function isEmpty(obj) {
  // null and undefined are "empty"
  if (obj == null) return true;

  // Assume if it has a length property with a non-zero value
  // that that property is correct.
  if (obj.length > 0) return false;
  if (obj.length === 0) return true;

  // If it isn't an object at this point
  // it is empty, but it can't be anything *but* empty
  // Is it empty?  Depends on your application.
  if (typeof obj !== 'object') return true;

  // Otherwise, does it have any properties of its own?
  // Note that this doesn't handle
  // toString and valueOf enumeration bugs in IE < 9
  for (var key in obj) {
    if (hasOwnProperty.call(obj, key)) return false;
  }

  return true;
}
// タスク詳細取得
export const getTaskDetail = (enterpriseId, token, taskId) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(
        Api.getTaskDetailApi,
        {
          code: 'task_get',
          enterpriseId,
          taskId
        },
        {
          headers: { Authorization: token }
        }
      )
      .then(res => {
        res = JSON.parse(res.data.body);
        console.log('TCL: getTaskDetail -> res -> task_get', token, res);
        if ('errorMessage' in res) {
          if (typeof res.errorMessage.errMsg == 'string') {
            dispatch(modalOpen(res.errorMessage.errMsg, '失敗'));
          } else {
            dispatch(modalOpen(res.errorMessage.errMsg.message, '失敗'));
          }
        } else {
          dispatch(saveTaskDetail(res.data));
        }
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(loadEnd());
      });
  };
};

export const saveTaskDetail = data => {
  return {
    type: Task.GET_TASK_DETAIL,
    data
  };
};

export const resetTaskDetail = () => {
  return {
    type: Task.RESET_TASK_DETAIL
  };
};

// タスク削除
export const taskDeleteAction = (enterpriseId, token, taskId) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(
        Api.taskDeleteApi,
        {
          code: 'task_delete',
          enterpriseId,
          taskId
        },
        {
          headers: { Authorization: token }
        }
      )
      .then(res => {
        res = JSON.parse(res.data.body);
        console.log('TCL: taskDeleteAction -> res', res);

        if ('errorMessage' in res) {
          dispatch(modalOpen(res.errorMessage.errMsg, '失敗'));
        } else {
          dispatch(resetTaskDetail);
          dispatch(deleteTaskDetail(res.data));
        }
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(loadEnd());
      });
  };
};

export const deleteTaskDetail = () => {
  return {
    type: Task.DELETE_TASK
  };
};

export const resetDeleteTask = () => {
  return {
    type: Task.RESET_DELETE_TASK
  };
};

// タスク編集
export const taskEditAction = params => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(
        Api.taskEditApi,
        {
          code: 'task_update',
          enterpriseId: params.enterpriseId,
          taskId: params.taskId,
          datas: {
            fee: params.fee,
            description: params.description
          }
        },
        {
          headers: { Authorization: params.token }
        }
      )
      .then(res => {
        res = JSON.parse(res.data.body);
        if ('errorMessage' in res) {
          dispatch(modalOpen(res.errorMessage, '失敗'));
        } else {
          dispatch(resetTaskDetail);
          dispatch(taskEditEnd());
        }
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(loadEnd());
      });
  };
};

export const taskEditEnd = () => {
  return {
    type: Task.EDIT_TASK
  };
};

export const taskEditReset = () => {
  return {
    type: Task.EDIT_TASK_RESET
  };
};

// 応募承認
export const entryApproval = (enterpriseId, token, taskId, taskrewId) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(
        Api.taskrewApprovalApi,
        {
          code: 'applicationApproval',
          enterpriseId,
          taskId,
          taskrewId,
          badCancelFlag: 0,
          admin: false
        },
        {
          headers: { Authorization: token }
        }
      )
      .then(res => {
        res = JSON.parse(res.data.body);
        // if ('errorMessage' in res) {
        //   dispatch(modalOpen(res.errorMessage.errMsg, '失敗'))
        // } else {
        //   // 承認時処理
        //   dispatch(entryApprovalSave())
        // }
        dispatch(entryApprovalSave());
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(loadEnd());
      });
  };
};

export const entryApprovalSave = () => {
  return {
    type: Task.APPLY_TASK
  };
};

export const resetEntryApprovalSave = () => {
  return {
    type: Task.RESET_APPLY_TASK
  };
};

// 施設側からの承認キャンセル
export const cancelApproval = (enterpriseId, token, taskId, taskrewId) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(
        Api.taskrewApprovalApi,
        {
          code: 'matchedCancel',
          enterpriseId,
          taskId,
          taskrewId,
          badCancelFlag: 0,
          admin: false
        },
        {
          headers: { Authorization: token }
        }
      )
      // eslint-disable-next-line no-unused-vars
      .then(res => {
        res = JSON.parse(res.data.body);
        // if ('errorMessage' in res) {
        //   dispatch(modalOpen(res.errorMessage.errMsg, '失敗'))
        // } else {
        //   // 承認時処理
        //   dispatch(entryApprovalSave())
        // }
        dispatch(cancelApprovalSave());
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(loadEnd());
      });
  };
};

export const cancelApprovalSave = () => {
  return {
    type: Task.CANCEL_TASK_FROM_ENTERPRISE
  };
};

export const resetCancelApprovalSave = () => {
  return {
    type: Task.RESET_CANCEL_TASK_FROM_ENTERPRISE
  };
};

// 応募者からのキャンセル依頼を承認
export const cancelRequestApproval = (enterpriseId, token, taskId, taskrewId, badCancelFlag) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(
        Api.taskrewApprovalApi,
        {
          code: 'cancelApproval',
          enterpriseId,
          taskId,
          taskrewId,
          badCancelFlag,
          admin: false
        },
        {
          headers: { Authorization: token }
        }
      )
      // eslint-disable-next-line no-unused-vars
      .then(res => {
        res = JSON.parse(res.data.body);
        // if ('errorMessage' in res) {
        //   dispatch(modalOpen(res.errorMessage.errMsg, '失敗'))
        // } else {
        //   // 承認時処理
        //   dispatch(entryApprovalSave())
        // }
        dispatch(cancelRequestApprovalSave());
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(loadEnd());
      });
  };
};

export const cancelRequestApprovalSave = () => {
  return {
    type: Task.CANCEL_TASK_FROM_USER
  };
};

export const resetCancelRequestApproval = () => {
  return {
    type: Task.RESET_CANCEL_TASK_FROM_USER
  };
};

// レビュー登録

export const taskReview = (enterpriseId, token, taskId, taskrewId, questions) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(
        Api.taskReviewApi,
        {
          code: 'create',
          admin: false,
          enterpriseId,
          taskId,
          taskrewId,
          ...questions
        },
        {
          headers: { Authorization: token }
        }
      )
      // eslint-disable-next-line no-unused-vars
      .then(res => {
        res = JSON.parse(res.data.body);
        // if ('errorMessage' in res) {
        //   dispatch(modalOpen(res.errorMessage.errMsg, '失敗'))
        // } else {
        //   // 承認時処理
        //   dispatch(entryApprovalSave())
        // }
        dispatch(saveReview());
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(loadEnd());
      });
  };
};

export const saveReview = () => {
  return {
    type: Task.SEND_REVIEW
  };
};

export const resetSaveReview = () => {
  return {
    type: Task.RESET_SEND_REVIEW
  };
};

// タスク登録
export const registerTask = (args, token) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(Api.taskCreateApi, args, {
        headers: { Authorization: token }
      })
      .then(res => {
        res = JSON.parse(res.data.body);
        if ('errorMessage' in res) {
          dispatch(modalOpen(res.errorMessage, '失敗'));
        } else {
          dispatch(registerTaskToReducer());
        }
        dispatch(loadEnd());
      })
      .catch(err => {
        dispatch(loadEnd());
      });
  };
};

export const registerTaskToReducer = () => {
  return {
    type: Task.REGISTER_TASK
  };
};

export const resetRegisterTask = () => {
  return {
    type: Task.RESET_REGISTER_TASK
  };
};

export const getInvoiceInfo = (token, enterpriseId) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(
        Api.getPaymentApi,
        {
          code: 'get_invoice',
          enterpriseId
        },
        {
          headers: { Authorization: token }
        }
      )
      .then(res => {
        res = JSON.parse(res.data.body);
        console.log('res==', res);
        if ('errorMessage' in res) {
          dispatch(modalOpen(res.errorMessage, '失敗'));
        } else {
          dispatch(saveInvoiceInfo(res.data));
        }
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(loadEnd());
      });
  };
};

export const getPaymentInfo = (token, enterpriseId, get_month) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(
        Api.getPaymentApi,
        {
          code: 'get_application',
          enterpriseId,
          get_month
        },
        {
          headers: { Authorization: token }
        }
      )
      .then(res => {
        res = JSON.parse(res.data.body);
        console.log('res==', res);
        if ('errorMessage' in res) {
          dispatch(modalOpen(res.errorMessage, '失敗'));
        } else {
          dispatch(savePaymentInfo(res.data));
        }
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(loadEnd());
      });
  };
};

export const setInvoiceStatus = (token, datas) => {
  return dispatch => {
    dispatch(loadStart());
    console.log('TCL: setInvoiceStatus -> datas', datas);
    axios
      .post(
        Api.getPaymentApi,
        {
          code: 'set_invoice_status',
          ...datas
        },
        {
          headers: { Authorization: token }
        }
      )
      .then(res => {
        res = JSON.parse(res.data.body);
        console.log('res==', res);
        if ('errorMessage' in res) {
          dispatch(modalOpen(res.errorMessage, '失敗'));
        } else {
          dispatch(saveInvoiceInfo(res.data));
          dispatch(modalOpen(res.data.message, '失敗'));
        }
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(loadEnd());
      });
  };
};

export const saveInvoiceInfo = data => {
  return {
    type: Task.SAVE_INVOICE_INFO,
    data
  };
};

export const resetInvoiceInfo = () => {
  return {
    type: Task.RESET_INVOICE_INFO
  };
};

export const savePaymentInfo = data => {
  return {
    type: Task.SAVE_PAYMENT_INFO,
    data
  };
};

export const resetPaymentInfo = () => {
  return {
    type: Task.RESET_PAYMENT_INFO
  };
};

export const setParticipantDetail = data => {
  return {
    type: Task.SET_PARTICIPANT,
    data
  };
};

export const saveTaskStatus = data => {
  return {
    type: Task.SET_TASK_STATUS,
    data
  };
};

export const getTaskStatus = () => {
  return {
    type: Task.GET_TASK_STATUS
  };
};
